<template>
  <v-layout xs12 row wrap pr-3 pl-3>
    <h3>Service Actions</h3>
     <v-flex xs12 py-1>
      <v-btn
        style="width: 100%;"
        color="red lighten-1"
        dark
        small
        class="text-none"
        @click="loadBookings"
      >Load Bookings</v-btn>
    </v-flex>
    <v-flex xs12 py-1>
      <v-btn
        style="width: 100%;"
        color="red lighten-1"
        dark
        small
        class="text-none"
        @click="cancelDates"
      >Cancel Between Dates</v-btn>
    </v-flex>
    <v-flex xs12>
      <v-btn
        style="width: 100%;"
        color="green lighten-1"
        dark
        small
        class="text-none"
        @click="recoverDates"
      >Recover Between Dates</v-btn>
    </v-flex>
    <v-flex xs12 py-1>
      <v-btn
        v-if="hasSelected"
        style="width: 100%;"
        color="red lighten-1"
        dark
        small
        class="text-none"
        @click="cancelSelected"
      >Cancel Selected</v-btn>
    </v-flex>
    <v-flex xs12>
      <v-btn
        v-if="hasSelected"
        style="width: 100%;"
        color="green lighten-1"
        dark
        small
        class="text-none"
        @click="recoverSelected"
      >Recover Selected</v-btn>
    </v-flex>
    <v-flex xs12 py-1>
      <v-btn
        v-if="repeatService.repeatServiceModel.trip_a.id != null"
        @click="alter"
        style="width: 100%;"
        small
        class="text-none"
      >Alter Trips</v-btn>
    </v-flex>
    <v-flex>
      <v-btn
        style="width: 100%;"
        small
        class="text-none"
        @click="viewChangelogDialog = true"
      >Changelog</v-btn>
    </v-flex>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ mode == 'cancel' ? "Cancel" : "Recover" }} Trips between Dates</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout mb-4 class="row wrap">
              <v-flex v-if="error != null" xs12 mb-2 px-2>
                <p style="color:red;">{{error}}</p>
              </v-flex>
              <v-flex pr-2 xs5>
                <BookingDateInput
                  @input="function() {}"
                  label="Start Date"
                  v-model="dateSpan.start_date"
                  :width="80"
                ></BookingDateInput>
              </v-flex>
              <v-flex pl-2 xs5>
                <BookingDateInput
                  @input="function() {}"
                  label="End Date"
                  v-model="dateSpan.end_date"
                ></BookingDateInput>
              </v-flex>
            </v-layout>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-radio-group label="Apply to:" v-model="outboundReturnSelector">
                  <v-radio label=" Outbound" :value="0"></v-radio>
                  <v-radio label=" Return" :value="1"></v-radio>
                  <v-radio label=" Outbound &amp; Return" :value="2"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn class="text-none" flat text @click="dialog = false">Close</v-btn>
          <v-btn
            class="text-none"
            flat
            text
            @click="submitDates"
          >{{ mode == 'cancel' ? "Cancel Trips" : "Recover Trips" }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="selectDialog" max-width="340">
      <v-card>
        <v-card-title class="headline">Confirm {{mode == 'cancel' ? "Cancel" : "Recover" }} Trips?</v-card-title>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn class="text-none" flat text @click="selectDialog = false">Close</v-btn>
          <v-btn class="text-none" flat text @click="submitSelectedBookings">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="viewChangelogDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="secondary">
          <v-btn icon dark @click="viewChangelogDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>View Changelog</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <Changelog :repeatService="repeatService" />
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";

import { RepeatService } from "@/components/util/RepeatService.js";
import BookingDateInput from "@/components/widget/input/BookingDateInput.vue";
import Changelog from "@/components/repeat_service/Changelog.vue";

import moment from "moment";
import axios from "axios";
import { setTimeout, clearTimeout } from "timers";

axios.defaults.withCredentials = true;

export default {
  name: "BulkActionOptions",
  components: {
    SimpleTextInput,
    BookingDateInput,
    Changelog,
  },
  model: {
    prop: "content",
    event: "input",
  },
  props: {
    repeatService: Object,
  },
  data() {
    return {
      menu: false,
      dialog: false,
      selectDialog: false,
      mode: null,
      outboundReturnSelector: 2,
      dateSpan: {
        start_date: null,
        end_date: null,
      },
      error: null,
      viewChangelogDialog: false,
    };
  },
  computed: {
    hasSelected: function () {
      if (this.repeatService.repeatServiceModel.trip_a != null) {
        var foundSelected = this.repeatService.repeatServiceModel.trip_a.repeat_booking_entries.find(
          function (t) {
            return t.booking.selected == true;
          }
        );

        if (foundSelected != null) {
          return true;
        }
      }

      if (this.repeatService.repeatServiceModel.trip_b != null) {
        var foundSelected = this.repeatService.repeatServiceModel.trip_b.repeat_booking_entries.find(
          function (t) {
            return t.booking.selected == true;
          }
        );

        if (foundSelected != null) {
          return true;
        }
      }

      return false;
    },
  },
  methods: {
    loadBookings: function() {
      this.$emit("loadBookings", null);
    },
    alter() {
      this.$emit("alter", null);
    },
    submitSelectedBookings() {
      this.repeatService.applyBulkSelectionAction(this.mode == "cancel");
      this.selectDialog = false;
    },
    submitDates() {
      this.error = this.validateDateSpan(this.dateSpan);

      if (this.error != null) {
        return;
      }

      this.repeatService.applyBulkDateAction(
        this.dateSpan,
        this.outboundReturnSelector,
        this.mode
      );

      this.dialog = false;
    },
    validateDateSpan: function (date_span) {
      console.log(date_span);
      try {
        var start = moment(date_span.start_date, "YYYY-MM-DD");
        var end = moment(date_span.end_date, "YYYY-MM-DD");

        if (start.isAfter(end)) {
          return "End date must be after start date";
        }
      } catch (e) {
        console.log(e);
        return "Error in date span - Please ensure dates were selected through calender / are in correct format";
      }

      return null;
    },
    cancelDates() {
      this.mode = "cancel";
      this.dialog = true;
    },
    recoverDates() {
      this.mode = "recover";
      this.dialog = true;
    },
    cancelSelected() {
      this.mode = "cancel";
      this.selectDialog = true;
    },
    recoverSelected() {
      this.mode = "recover";
      this.selectDialog = true;
    },
  },
};
</script>

